import { ITEM_STATE_CHECKED, ITEM_STATE_DISABLED } from '@vfde-brix/form-selection-control';
import { JustText } from '@vfde-brix/just-text';
import {
    createOptionPickerComponent,
    OptionPicker,
} from '@vfde-brix/option-picker';
import { findSubscription, findTariffById } from '../container/App/helpers/selectorHelper';
import { SelectedOption } from '../container/App/interface';
import { SalesChannel } from '../enum';
import { is5g } from '../helper/additionalPageOptionsHelper';
import { areIdsEqual } from '../helper/validator';
import { Id } from '../interface/AdditionalPageOptions';
import Data from '../interface/dto/Data';
import { Tariff } from '../interface/dto/Tariffs';

const getState = (currentHardwareId: string, selectedHardwareId: Id, sub?: Tariff) => {

    if (!sub) {
        return ITEM_STATE_DISABLED;
    } else if (areIdsEqual(currentHardwareId, selectedHardwareId)) {
        return ITEM_STATE_CHECKED;
    }

    return undefined;
};

export const updateOptionPicker = (
    comp: OptionPicker | null,
    hardwareHint: JustText | null,
    tariffs: Data[],
    selected: SelectedOption,
    sales: SalesChannel
) => {

    if (!comp){
        return;
    }
    const items = comp.getProperties().items;

    items.forEach(item => {
        const tariff = findTariffById(tariffs, item.stdValue);
        const sub = findSubscription(tariff, selected.subscriptionId, sales);

        item.optState = getState(item.stdValue, selected.hardwareId, sub);

        const showHint = is5g(item.stdValue) && item.optState === ITEM_STATE_DISABLED;

        hardwareHint?.toggleContainer(!showHint);
    });

    comp.update({ items });
};

const mountOptionPicker = (wrapperId: string, onChange: (id: string) => void) => {
    const container = document.getElementById(wrapperId);

    return container && createOptionPickerComponent(container, {
        onChange: e => onChange((e.currentTarget as HTMLInputElement).value),
    });
};

export default mountOptionPicker;
